import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToggleService {
  private toggleSubject = new BehaviorSubject<boolean>(false);
  isToggled$ = this.toggleSubject.asObservable();

  toggle() {
    this.toggleSubject.next(!this.toggleSubject.value);
  }
}
